import { canPlayCodec } from "../canPlay";
import type { PlayableItem } from "../types";
import { defineKind } from "./base";

const playsHere = (item: PlayableItem) => canPlayCodec(item.codec, "audio");

/**
 * A live radio stream (Icecast / Shoutcast, HLS radio) in our audio player: from the live edge, no seek, never ends
 * by itself. room-stc's `stream` provider; a stream is a radio when live (rows before the backfill: RADIO_STREAM).
 */
export const radio = defineKind({
  id: "radio",
  provider: "stream",
  types: ["RADIO_STREAM"],
  matches: (item) => item.live === true || item.type === "RADIO_STREAM",
  surface: "audio",
  icon: "radio",
  caps: { live: true, castable: true, queueable: true, dockable: true },
  label: (t) => t("cast_item_radio", "Radio"),
  meta: (t) => t("wall_item_radio", "Radio stream · live"),
  canPlay: playsHere,
  // A slot that says only MUSIC plays live: safe for an audio file too (no seek).
  slot: { mediaType: "MUSIC", fallback: true },
});

/** An audio file link (MP3, AAC, Ogg, …) in our audio player. */
export const audioFile = defineKind({
  id: "audio",
  provider: "stream",
  types: ["AUDIO_URL"],
  surface: "audio",
  icon: "music",
  caps: { seekable: true, endsByItself: true, castable: true, queueable: true, dockable: true },
  label: (t) => t("cast_item_audio", "Audio"),
  meta: (t) => t("wall_item_audio", "Audio"),
  typeLabel: (t) => t("wall_type_audio", "Audio file"),
  canPlay: playsHere,
  slot: { mediaType: "MUSIC" },
});
